import { useFormikContext } from "formik";
import { useEffect } from "react";
import scrollToTheFirstErrorOnPage from "../../utils/scroll-to-error";

function ScrollToFormError(props) {
  const formik = useFormikContext();
  useEffect(() => {
    scrollToTheFirstErrorOnPage();
  }, [formik?.submitCount]);
  return <>{props.children}</>;
}
export default ScrollToFormError;
